module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/neutralCalification.6504c7d6.svg";